import { useState, useEffect } from 'react';
import {
  ModalCWShellUI,
  DescriptionUI,
} from '@next-order/next-order-components';

function LogOutConfirmationModal({ open, onCancel, onOpenChange, onConfirm }) {
  const [showModal, setShowModal] = useState(open);

  useEffect(() => {
    setShowModal(open);
  }, [open]);

  const handleClose = () => {
    setShowModal(false);
    onCancel?.();
  };

  const handleConfirm = () => {
    setShowModal(false);
    onConfirm?.();
  };

  return (
    <ModalCWShellUI
      open={showModal}
      onOpenChange={onOpenChange}
      maxWidth={460}
      zIndex={9999}
      maxHeight='full'
    >
      <ModalCWShellUI.CloseButton
        onClick={handleClose}
        extendedClassName='ml-auto left-4'
      />
      <ModalCWShellUI.Header
        extendedHeadingClassName='w-full text-center text-xl md:text-2xl'
        title='Are you sure you want to log out?'
      />
      <ModalCWShellUI.Footer>
        <ModalCWShellUI.Button
          variant='outlined'
          onClick={handleClose}
          extendedClassName='w-full'
        >
          Cancel
        </ModalCWShellUI.Button>
        <ModalCWShellUI.Button
          onClick={handleConfirm}
          extendedClassName='w-full'
        >
          Log Out
        </ModalCWShellUI.Button>
      </ModalCWShellUI.Footer>
    </ModalCWShellUI>
  );
}

export default LogOutConfirmationModal;
